import { get, update, post, remove } from "../helper/apiMethods";
//import makeToast from "../components/Snackbar";

export const getScreeningEventStats = async ()=> {
	try {
		const res = await get("/screeningevent/stats")
		return res
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getScreeningEventStatsThisMonth = async ()=> {
	try {
		const res = await get("/screeningevent/stats/thismonth")
		return res
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getAllScreeningEvents = async () => {
	try {
		const res = await get("/screeningevent/Listofscreeningevents")
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
export const getScreeningEventsById = async (id: string) => {
	try {
		const res = await get(`/screeningevent/${id}`)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
//i need type on values for protection
export const addScreeningEvents = async (values) => {
	try {
		const res = await post("/screeningevent/addscreeningevent",values)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
//i need type on values for protection
export const updateScreeningEvents = async (id: string, values) => {
	try {
		const res = await update(`/screeningevent/update/${id}`, values)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
export const deleteScreeningEvents = async (id: string) => {
	try {
		const res = await remove(`/screeningevent/delete/${id}`)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}

export const getAvailableMedecin = async (date: string, excludeEventId?: string)=>{
	try {
		const query = excludeEventId ? `?excludeEventId=${excludeEventId}` : "";
		const res = await get(`/screeningevent/medecin/listAvailableMedecin/${date}${query}`);
		return res.data ? res.data : false;
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getCurrentEvent = async()=>{
	try {
		const res = await get('/screeningevent/me/today/');
		return res.data ? res.data : false;
	} catch (error) {
		return Promise.reject(error)
	}
}

export const getAllCampaigns = async () => {
	try {
		const res = await get("/campaign/Listofcampaigns")
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}

export const getCampaignById = async (id: string) => {
	try {
		const res = await get(`/campaign/${id}`)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}

export const getCampaignByNumeroFacture = async (id: string, currentId?: string) => {
  try {
    const query = currentId ? `?currentId=${currentId}` : "";
    const res = await get(`/campaign/numerofacture/${id}${query}`);
    return res.response
  } catch (error) {
    return Promise.reject(error);
  }
};

export const addCampaign = async (values) => {
	try {
		const res = await post("/campaign/addcampaign",values)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}

export const updateCampaign = async (id: string, values) => {
	try {
		const res = await update(`/campaign/update/${id}`, values)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}

export const deleteCampaign = async (id: string) => {
	try {
		const res = await remove(`/campaign/delete/${id}`)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}